<template>
  <div class="promotion page">
    <div class="pc-container" v-if="isPc">
      <div v-show="type === 'production'" class="production">
        <img src="../assets/images/pc/promotion/production_01.jpg" />
        <div>
          <img src="../assets/images/pc/promotion/production_02.jpg" />
          <img @click="handleChange" data-type="production" class="button button_production_active" src="../assets/images/pc/promotion/button_production_active.png"/>
          <img @click="handleChange" data-type="digita" class="button button_digita_normal" src="../assets/images/pc/promotion/button_digita_normal.png"/>
        </div>
         <div v-for="(image, index) in productionPcImages" :key="index">
            <img class="lazyload" :data-src="image" />
             <div class="digita-primary-container scroll_content" :class="(digita.primary && digita.primary.length > 10) && 'scroll_content'" v-if="index === 0">
              <div class="img-body">
                <img class="content" style="width: 70% !important;left: 12%" src="../assets/images/pc/promotion/content01.png" />
              </div>
          </div>
         </div>
      </div>
      <div v-show="type === 'digita'" class="digita">
        <img src="../assets/images/pc/promotion/digita_01.jpg" />
        <div>
          <img src="../assets/images/pc/promotion/digita_02.jpg" />
          <img @click="handleChange" data-type="production" class="button button_production_normal" src="../assets/images/pc/promotion/button_production_normal.png"/>
          <img @click="handleChange" data-type="digita" class="button button_digita_active" src="../assets/images/pc/promotion/button_digita_active.png"/>
        </div>
        <div v-for="(image, index) in digitaPcImages" :key="index">
          <img class="lazyload" :data-src="image" />
          <div class="digita-primary-container scroll_content" :class="(digita.primary && digita.primary.length > 10) && 'scroll_content'" v-if="index === 0">
            <!-- <div class="list-item" v-for="(item, index) in digita.primary" :key="`primary${index}`">
              <div class="list-item__no">{{index + 1}}</div>
              <div class="list-item__name">{{item.Team.Name}}</div>
              <div class="list-item__grade">{{item.Score}}</div>
            </div> -->
            <div class="img-body">
              <img class="content" style="width: 70% !important;left: 12%" src="../assets/images/pc/promotion/content1.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-container">
      <div v-show="type === 'production'" class="production">
        <img src="../assets/images/mobile/promotion/production_01.jpg" />
        <div>
          <img src="../assets/images/mobile/promotion/production_02.jpg" />
          <img @click="handleChange" data-type="production" class="button button_production_active" src="../assets/images/pc/promotion/button_production_active.png"/>
          <img @click="handleChange" data-type="digita" class="button button_digita_normal" src="../assets/images/pc/promotion/button_digita_normal.png"/>
        </div>
        <div v-for="(image, index) in productionMobileImages" :key="index">
          <img class="lazyload" :data-src="image" />
          <div class="digita-primary-container scroll_content" v-if="index === 0">
            <div class="img-body">
              <img class="content" style="width: 85%;left: 5%" src="../assets/images/mobile/promotion/content01.png" />
            </div>
          </div>
         </div>
      </div>
      <div v-show="type === 'digita'" class="digita">
        <img src="../assets/images/mobile/promotion/digita_01.jpg" />
        <div>
          <img src="../assets/images/mobile/promotion/digita_02.jpg" />
          <img @click="handleChange" data-type="production" class="button button_production_normal" src="../assets/images/pc/promotion/button_production_normal.png"/>
          <img @click="handleChange" data-type="digita" class="button button_digita_active" src="../assets/images/pc/promotion/button_digita_active.png"/>
        </div>
        <div v-for="(image, index) in digitamobileImages" :key="index">
          <img class="lazyload" :data-src="image" />
          <div class="digita-primary-container scroll_content" v-if="index === 0">
            <!-- <div class="list-item" v-for="(item, index) in digita.primary" :key="`primary${index}`">
              <div class="list-item__no">{{index + 1}}</div>
              <div class="list-item__name">{{item.Team.Name}}</div>
              <div class="list-item__grade">{{item.Score}}</div>
            </div> -->
             <div class="img-body">
               <img class="content" style="width: 85%;left: 5%" src="../assets/images/mobile/promotion/content1.png" />
             </div>
          </div>
         </div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from '../utils/'
import { mapState } from 'vuex'

export default {
  components:{
  },
  data() {
    return {
      type: 'production',
      productionPcImages: new Array(4).fill('').map((item, index) => {
        return require(`../assets/images/pc/promotion/production_0${index + 3}.jpg`)
      }),
      digitaPcImages: new Array(4).fill('').map((item, index) => {
        return require(`../assets/images/pc/promotion/digita_0${index + 3}.jpg`)
      }),
      productionMobileImages: new Array(3).fill('').map((item, index) => {
        return require(`../assets/images/mobile/promotion/production_0${index + 3}.jpg`)
      }),
      digitamobileImages: new Array(3).fill('').map((item, index) => {
        return require(`../assets/images/mobile/promotion/digita_0${index + 3}.jpg`)
      }),
      isPc: Utils.isPc()
    }
  },
  computed: {
    ...mapState(['digita'])
  },
  mounted(){
    this.getCurrentType()
    if (Utils.isPc()) {
      Utils.lazyloadImages('.pc-container .lazyload')
      setTimeout(() => {
        Utils.lazyloadImages('.mobile-container .lazyload')
      }, 1000)
      return
    }
    Utils.lazyloadImages('.mobile-container .lazyload', 100)
    setTimeout(() => {
      Utils.lazyloadImages('.pc-container .lazyload')
    }, 1000)
  },
  methods: {
    handleChange (e) {
      const { type } = e.target.dataset
      const { params } = this.$route
      if (type === params.type) return
      this.$router.replace(`/pingancx/promotion/${type}`)
      this.getCurrentType()
    },
    getCurrentType () {
      let type = this.$route.params.type;
      const types = ['production', 'digita']
      if (types.indexOf(type) === -1) {
        type = 'production';
      }
      this.type = type
      document.querySelectorAll(`.lazyload`).forEach(item => {
        const { src } = item.dataset
        if (item.src) return
        setTimeout(() =>{
          item.src = src
        }, 90)
      })
    }
  }
}
</script>
<style>
.promotion,
.promotion img{
  width: 100%;
}
.promotion .button{
  position: absolute;
  left: 0px;
  top: 0px;
}
.promotion .button_digita_normal{
  width: 6.927%;
  right: 39vw;
  left: auto;
  top: 37.29%;
}
.promotion .button_digita_active{
  width: 11.7%;
  right: 39vw;
  left: auto;
  top: 24.623%;
}
.promotion .button_production_active{
  width: 11.7%;
  left: 38.08vw;
  top: 24.623%;
}
.promotion .button_production_normal{
  width: 6.927%;
  left: 38.08vw;
  top: 37.29%;
}
.promotion .digita-primary-container{
  position: absolute;
  width: 38%;
  height: 57%;
  top: 36%;
  left: 50%;
  transform: translateX(-50%);
}
.mobile-container .button_production_active{
  width: 17.85%;
  left: 30.08vw;
  top: 31.623%;
}
.mobile-container .button_digita_normal{
  width: 13.39%;
  right: 30vw;
  left: auto;
  top: 38.29%;
}
.mobile-container .button_production_normal{
  width: 13.39%;
  left: 30.08vw;
  top: 38.29%;
}
.mobile-container .button_digita_active{
  width: 17.85%;
  right: 30vw;
  left: auto;
  top: 31.623%;
}
.list-item{
  display: flex;
  font-size: 2rem;
  justify-content: space-around;
}
.list-item div{
  flex: 1;
  padding: 0 3%;
  color: #fff;
  font-size: 2.5rem;
  line-height: 6rem;
}
.list-item .list-item__no{
  text-align: left;
  flex: 0.38;
  text-align: center;
}
.list-item .list-item__name{
  text-align: center;
  word-break: keep-all;
  white-space: nowrap;
}
.list-item .list-item__grade{
  text-align: right;
  flex: 0.38;
  text-align: center;
}

.mobile-container .digita-primary-container{
  width: 69%;
}
.mobile-container .list-item div{
  font-size: 12px;
  line-height: 20px;
}

.promotion .scroll_content{
  overflow-y: scroll;
}

/*webkit内核*/
.promotion .scroll_content::-webkit-scrollbar {
  width: 1.3rem;
  background-image: url('../assets/images/pc/promotion/scroll_bg.png');
  background-size: 100% 100%;
}

/*o内核*/
.promotion .scroll_content .-o-scrollbar{
  width: 6px;
  background-image: url('../assets/images/pc/promotion/scroll_bg.png');
  background-size: 100% 100%;
}

.promotion .scroll_content::-webkit-scrollbar-thumb
{
  width: 6px;
  background-image: url('../assets/images/pc/promotion/scroll_block.png');
  background-size: 100% 100%;
}

.promotion .mobile-container .scroll_content::-webkit-scrollbar{
  width: 10px;
}
.img-body{
  width: fit-content;
  height: fit-content;
  width: 100%;
  position: relative;
}
</style>